function returnOptions(data) {
  // 重制时间
  const timeList = data.map((item) => item.dateTime);
  // 重定销售总额
  const resultAmountList = data.map((item) => item.resultAmount);
  // 重定环比增长率
  const chainGrowthList = data.map((item) => item.chainGrowth);
  return {
    color: ['#fe6d6c', '#339cf2'],
    legend: {
      right: '15%',
      data: ['销售总额（元）', '环比增长率（%）'],
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#FFFFFF',
      textStyle: {
        color: '#B5B5B5',
        fontSize: 14
      },
      axisPointer: {
        type: 'cross',
      },
      padding: 10,
      extraCssText: 'box-shadow:0px 6px 24px 6px rgba(37,41,44,0.06);',
      formatter(params) {
        let str = `${params[0].name}<br/>`;
        params.forEach((item) => {
          if (item.seriesName == '销售总额（元）') {
            str += `${item.marker + item.seriesName}:     ${item.data}<br/>`;
          } else if (item.seriesName == '环比增长率（%）') {
            str += `${item.marker + item.seriesName}:     ${item.data}%`;
          }
        });
        return str;
      }
    },

    grid: {
      right: '20%'
    },
    xAxis: {
      type: 'category',
      data: timeList,
      axisPointer: {
        type: 'shadow'
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '销售总额（元）',
        // min: Math.min.apply(null, resultAmountList),
        // max: Math.max.apply(null, resultAmountList),
        // interval: 50,
        axisLabel: {
          formatter: '{value} '
        },
        splitLine: {
          show: false
        }
      },
      {
        type: 'value',
        name: '环比增长率（%）',
        // min: Math.min.apply(null, chainGrowthList),
        max: Math.max.apply(null, chainGrowthList),
        // interval: 50,
        axisLabel: {
          formatter: '{value}%'
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: [{
      name: '销售总额（元）',
      type: 'bar',
      tooltip: {
        trigger: 'axis'
      },
      yAxisIndex: 0,
      data: resultAmountList
    },
    {
      name: '环比增长率（%）',
      type: 'line',
      tooltip: {
        trigger: 'axis'
      },
      yAxisIndex: 1,
      data: chainGrowthList,
      // 提示
      // label: {
      //   normal: {
      //     show: true,
      //     position: 'top',
      //     formatter(parames) {
      //       return `${parames.value}%`;
      //     }
      //   }
      // }
    },
    ]
  };
}
export const echartsA = returnOptions;
